import '../../Orders.scss';

import { Button } from '@travelwin/core';
import { useState } from 'react';

import { useNavigate } from '../../../../components/Link';
import LoginSignUpModal from '../../../../components/LoginSignUpModal';

const className = 'p-Orders';
interface LoggedOutUserViewProps {
  cardTitle: string;
  cardText: string;
  buttonText: string;
  returnPath?: string;
  showLogin?: boolean;
}

export const LoggedOutUserView = ({
  cardTitle,
  cardText,
  buttonText,
  returnPath,
  showLogin = false,
}: LoggedOutUserViewProps) => {
  const [isShowLogin, setIsShowLogin] = useState(showLogin);

  const navigate = useNavigate();
  return (
    <>
      <div className={`${className}__login-card`}>
        <h2 className={`${className}__login-card--title`}>{cardTitle}</h2>
        <p className={`${className}__login-card--text`}>{cardText}</p>
        <div className={`${className}__login-card--button`}>
          <Button
            fluid
            onClick={() => setIsShowLogin(true)}
            data-testid="button-login-or-signup"
          >
            {buttonText}
          </Button>
        </div>
      </div>

      <LoginSignUpModal
        on={isShowLogin}
        toggle={() => setIsShowLogin(false)}
        afterAuthPath={returnPath}
        handleCompleted={() => {
          if (returnPath) {
            navigate(returnPath);
          } else setIsShowLogin(false);
        }}
      />
    </>
  );
};
